/**
 * MIRA — axios client.
 * All MIRA requests are sent with the JWT we store under `mira_token`.
 */
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const mira = axios.create({
  baseURL: `${API_BASE}/api/mira`,
  timeout: 30000,
});

mira.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('mira_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

mira.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('mira_token');
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/mira/login')) {
        window.location.href = '/mira/login';
      }
    }
    return Promise.reject(err);
  }
);

export default mira;

/** Coerce any backend error payload into a single user-readable string. */
export const errMsg = (e, fallback = 'Something went wrong') => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d) && d.length) return d.map((x) => x?.msg || x?.message || 'Invalid input').join(' · ');
  if (d && typeof d === 'object') return d.msg || d.message || fallback;
  return e?.message || fallback;
};

/** Fire-and-forget analytics event — never blocks the user flow. */
export const trackEvent = (name, payload = {}) => {
  if (!localStorage.getItem('mira_token')) return;
  mira.post('/events', { name, payload }).catch(() => {});
};
